import ThemeOption from "./themeOption.js";
import { createTheme } from "@mui/material/styles";

export default createTheme(ThemeOption);
